import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';

import { SharingModule } from '../SharedModule';

import { EventDetailRoutingModule } from './event-detail-routing.module';
import { EventDetailComponent } from './event-detail.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	imports: [
		CommonModule,
		EventDetailRoutingModule,
		LazyLoadImageModule.forRoot({
			preset: intersectionObserverPreset
		}),
		SharingModule.forRoot(),
		NgbModule.forRoot(),
	],
	
	declarations: [
		EventDetailComponent,
	],
})
export class EventDetailModule { }